import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Contractor } from '../models';

@Injectable({
    providedIn: 'root'
})
export class ContractorService {

    constructor(private http: HttpClient) { }

    getByPolicyNumber(policyNumber: string): Observable<Contractor[]> {
        return this.http.get(`${environment.server.api.portalpas}/Policy/${policyNumber}/ca7-contractors`).pipe(
            map((response: { contractors: Contractor[] }) => response && response.contractors)
        );
    }
}
